import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2019 } from "../../../../data/Convenios/dataConvenios";

const Convenios2019 = () => <ConveniosYearPage year={2019} data={convenios2019} />;

export default Convenios2019;